import { FcDocument } from "react-icons/fc";
import React from "react";
import i18n from "i18next";
import "./RenderFile.css";

// Plain function (not a component), so it reads translations from the i18next instance.
const tr = key => i18n.t(key, { ns: "dashboard", nsSeparator: false, keySeparator: false });

export const renderFile = (file, noDownload) => {
  if (!file?.url) return null;

  if (file?.fileType?.startsWith("video")) {
    return (
      <video
        src={file?.url}
        style={{ minHeight: "200px", maxWidth: "100%" }}
        controls
        className="w-fit messageFile"
      />
    );
  } else if (
    file?.format === "png" ||
    file?.format === "jpeg" ||
    file?.format === "jpg" ||
    file?.format === "svg"
  ) {
    return (
      <div className="messageFile">
        <img
          src={file?.url}
          style={{ minHeight: "200px", maxWidth: "100%" }}
          className="w-fit"
          alt={file?.name || tr("Uploaded file")}
        />
        <br />
        {!noDownload && (
          <a href={file?.url} download target="_blank" rel="noreferrer" className="mt-3">
            {tr("Download")}
          </a>
        )}
      </div>
    );
  } else {
    return (
      <a
        href={file?.url}
        target="_blank"
        rel="noreferrer"
        download
        className="messageFileLink d-flex align-items-center gap-2"
      >
        <FcDocument style={{ fontSize: "60px", flexShrink: 0 }} /> {file?.name}
      </a>
    );
  }
};
